import {supabase} from '@/services/supabaseClient';
// Invalidation only: never copy permission data or authority between tabs.
const topic = 'afrimed:referral-consent-changed';
export function invalidateReferralConsent() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(topic));
  try { localStorage.setItem(topic, `${Date.now()}:${Math.random()}`); } catch { /* private storage */ }
  if (typeof BroadcastChannel !== 'undefined') {
    const channel = new BroadcastChannel(topic);
    channel.postMessage('invalidate');
    channel.close();
  }
}
export function subscribeReferralConsent(refresh) {
  let timer;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 30); };
  // Server invalidation also reaches separately signed-in windows/devices.
  // Realtime applies the standing-authorisation Patient read policy.
  const server = supabase.channel(`${topic}:${Math.random()}`)
    .on('postgres_changes', {event:'*',schema:'public',table:'referral_standing_authorisations'}, () => schedule())
    .subscribe(status => { if (status === 'SUBSCRIBED') schedule(); });
  const storage = event => { if (event.key === topic) schedule(); };
  const visible = () => { if (document.visibilityState === 'visible') schedule(); };
  const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(topic) : null;
  if (channel) channel.onmessage = schedule;
  window.addEventListener(topic, schedule);
  window.addEventListener('storage', storage);
  window.addEventListener('focus', schedule);
  document.addEventListener('visibilitychange', visible);
  return () => {
    clearTimeout(timer); channel?.close();
    void supabase.removeChannel(server);
    window.removeEventListener(topic, schedule);
    window.removeEventListener('storage', storage);
    window.removeEventListener('focus', schedule);
    document.removeEventListener('visibilitychange', visible);
  };
}
